import * as ConfigOperations from './operations';
import ConfigReducer from './reducer';

export { ConfigOperations };

export default ConfigReducer;
